export const styles = {
  content: {
    p: 3,
  },
  agreementContent: {
    maxHeight: 500,
    overflow: 'auto',
    border: 1,
    borderColor: 'divider',
    borderRadius: 1,
    p: 2,
    '& img': {
      maxWidth: '100%',
    },
  },
  htmlSegment: {
    '& p': {
      margin: 0,
    },
  },
  slotInlineContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    py: 1.5,
  },
  initialsButton: {
    width: 160,
    height: 96,
  },
  signatureButton: {
    width: '100%',
    height: 96,
  },
  signedSlot: {
    border: 1,
    borderColor: 'gray.12',
    borderRadius: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '&:hover': {
      borderColor: 'gray.32',
      backgroundColor: 'gray.3',
    },
  },
  signedInitialsSlot: {
    width: 160,
    height: 96,
  },
  signedSignatureSlot: {
    width: '100%',
    height: 96,
  },
  signedImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  readOnlySignature: {
    maxWidth: '100%',
    maxHeight: 96,
    objectFit: 'contain',
  },
  readOnlyInitials: {
    maxWidth: 160,
    maxHeight: 96,
    objectFit: 'contain',
  },
}
